import {ChangeDetectorRef, Component, EventEmitter, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Vehicle} from '../../models/vehicle';
import {Travel} from '../../models/travel';
import {TravelsHandlerService} from '../../api-handlers/travels-handler.service';
import {SnackBarHandlerService} from '../../commons/snack-bar-handler.service';
import {AuthService} from '../../auth-n-routing/auth-service.service';
import {Motivation} from '../../models/travel-motivation';
import {User} from '../../models/user';
import { Itinerario } from '../../models/itinerario';

@Component({
	selector: 'app-assign-user-to-car',
	templateUrl: './assign-user-to-car.component.html',
	styleUrls: ['./assign-user-to-car.component.scss']
})
export class AssignUserToCarComponent implements OnInit {

	modalRef: BsModalRef;
	vehicleToSet: Vehicle;
	new_travel: Travel;
	@ViewChild('template', { static: false }) template;
	@ViewChild('listGroup', { static: false }) listGroup;
	@Output() vehicleAssigned = new EventEmitter();
	travelMotivations: Motivation[] = [];
	selectedMotivation: Motivation;
	itinerario: Itinerario[] = [
		{
		  da: '',
		  a: '',
		  ar: true
		},
	  ];

	dom_elements = {
		assign_btn: {
			is_running: false,
			txt_run: 'ASSEGNAZIONE IN CORSO...',
			txt_not_run: 'ASSEGNA'
		}
	};

	mydataz = {
		users: []
	};

	constructor(public authService: AuthService,
				public travelsHandlerService: TravelsHandlerService,
				public snackBarHandler: SnackBarHandlerService,
				private modalService: BsModalService,
				private changeDetector: ChangeDetectorRef,
				private ngZone: NgZone) { }

	ngOnInit() {
		this.travelsHandlerService.getTravelMotivations().then((motivationsRes: Motivation[]) => {
			this.travelMotivations = motivationsRes;
			this.changeDetector.detectChanges();
		});
	}

	onMotivationChange(event){
		this.new_travel.motivation = this.selectedMotivation.id;
		this.new_travel.motivation_name = this.selectedMotivation.name;

		if (this.selectedMotivation.name !== 'Altro') {
			this.new_travel.motivation_other = '';
		}
	}

	showDialog(vehicleToAssign: Vehicle, date_from?: Date, date_to?: Date) {
		console.log(vehicleToAssign);
		this.vehicleToSet = vehicleToAssign;

		this.new_travel = new Travel(undefined);
		if ( date_from != null && date_to != null) {
			console.log(date_from + ' ' + date_to);
			this.new_travel.required_from = date_from;
			this.new_travel.required_to = date_to;
		}

		this.new_travel.vehicle = this.vehicleToSet;
		this.modalRef = this.modalService.show(this.template);
	}

	setAndApprove() {
		this.dom_elements.assign_btn.is_running = true;
		if (this.isRequestTravelComplete()) {
			this.new_travel.route = JSON.stringify(this.itinerario);
			this.new_travel.route_modified = false;

			this.travelsHandlerService.addTravel(this.new_travel, this.vehicleToSet.park.id.toString(), '').then(
				(travel: Travel) => {
					this.new_travel = travel;

					this.travelsHandlerService.approveTravel(this.new_travel, this.vehicleToSet, true).then(
						() => {
							this.snackBarHandler.showSnackbar('Operazione eseguita con successo', 3000);
							this.vehicleAssigned.next(undefined);
							this.modalRef.hide();
						}
					).catch( (e) => {
						this.snackBarHandler.showSnackbar('Attenzione assegnare auto. ' +
							'Verifica che l\'utente e l\'auto scelti siano liberi per le date selezionate', 3000);
					}).then(() => {
						this.dom_elements.assign_btn.is_running = false;
					});
				}
			).catch( (e) => {
				this.snackBarHandler.showSnackbar('Attenzione impossibile creare viaggio. ' +
					'Verifica che l\'utente scelto non abbiamo già un viaggio aperto per le date selezionate', 3000);
			}).then(() => {
				this.dom_elements.assign_btn.is_running = false;
			});
		} else {
			this.dom_elements.assign_btn.is_running = false;
		}
	}

	isRequestTravelComplete(): boolean {
		let isComplete = false;

		if (!this.isItinerarioValid()) {
			this.snackBarHandler.showSnackbar('Impostare itinerario valido', 3000);
		} else if (!this.new_travel.motivation || this.new_travel.motivation === -1) {
			this.snackBarHandler.showSnackbar('Impostare la motivazione del viaggio', 3000);
		} else if (!this.new_travel.required_from) {
			this.snackBarHandler.showSnackbar('Impostare data di inizio richiesta', 3000);
		} else if (!this.new_travel.required_to) {
			this.snackBarHandler.showSnackbar('Impostare data di fine richiesta', 3000);
		} else if (!this.new_travel.user || !this.new_travel.user.id ) {
			this.snackBarHandler.showSnackbar('Impostare l\'utente', 3000);
		} else if (this.new_travel.required_from > this.new_travel.required_to) {
			this.snackBarHandler.showSnackbar('Data inizio maggiore di data fine', 3000);
		} else {
			isComplete = true;
		}

		return isComplete;
	}

	onUserNameChanged(value: string) {

		this.new_travel.user = null;
		if (value && value.length > 2) {
			let v = value.trim();
			v = v.replace(/ /g, '');
			this.authService.findUser(v).then((users: User[]) => {
				this.ngZone.run(() => {
					this.mydataz.users = users;
					if (users.length > 0) {
						this.new_travel.user = users[0];
					}

				});

			});
		}

	}

	userSelected(user: User) {
		this.new_travel.user = user;
	}

	isItinerarioValid(): boolean {
		let validity = true;
		
		this.itinerario.forEach((item) => {
			if (item.da.length === 0 || item.a.length === 0) {
				validity = false;
			}
		});

		return validity;
	}
}
